function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DominicaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4283",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4283)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#279E19"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4283",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4283)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3H13.5V13.5H24V15H13.5V21H12V15H0V13.5H12V3Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 3H12V12H24V13.5H12V21H10.5V13.5H0V12H10.5V3Z",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 3H10.5V10.5H24V12H10.5V21H9V12H0V10.5H9V3Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
        fill: "#C51918"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.0444 9.30971C11.0444 9.30971 11.3294 8.38501 11.9914 8.86272C13.0294 9.374 13.3718 9.96137 13.7726 10.6266C14.1733 11.2917 12.79 10.8046 12.5319 10.4302C12.2738 10.0558 10.8424 9.93443 11.0444 9.62207C11.2465 9.30971 11.0444 9.30971 11.0444 9.30971Z",
        fill: "#804BFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.8098 14.0441C10.8098 14.0441 10.105 15.0082 10.8098 15.0082C11.5146 15.0082 14.3719 14.8008 14.0294 14.5261C13.6869 14.2515 11.1485 14.5261 11.1485 14.5261L10.8098 14.0441Z",
        fill: "#A95601"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.8635 14.0137C11.7904 13.9313 10.5063 11.0174 11.1033 10.4117C11.7004 9.80612 12.0503 10.162 12.0503 11.0701C12.0503 11.9783 12.0862 14.2381 11.8635 14.0137Z",
        fill: "#804BFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.788 13.5408C11.788 13.5408 11.7139 14.2491 12.0781 15.076C12.4424 15.9028 13.1781 15.8869 13.1781 15.2101C13.1781 14.5334 13.7151 15.1685 13.9212 15.6202C14.1274 16.0718 13.5935 11.6094 12.8358 10.611C12.0781 9.6127 11.347 9.5486 11.5675 10.1937C11.788 10.8389 11.788 13.5408 11.788 13.5408Z",
        fill: "#279E19"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3455 8.7C11.3455 8.7 11.025 8.90553 11.025 9.47163C11.025 10.0377 11.7838 9.29636 11.7838 9.29636L11.3455 8.7Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4137 8.48514L12.075 8.1375L12.7362 8.48514L12.6099 7.74882L13.1449 7.22735L12.4056 7.11992L12.075 6.45L11.7443 7.11992L11.005 7.22735L11.54 7.74882L11.4137 8.48514ZM11.4137 17.3351L12.075 16.9875L12.7362 17.3351L12.6099 16.5988L13.1449 16.0773L12.4056 15.9699L12.075 15.3L11.7443 15.9699L11.005 16.0773L11.54 16.5988L11.4137 17.3351ZM15.6137 13.1351L15.74 12.3988L15.205 11.8773L15.9443 11.7699L16.275 11.1L16.6056 11.7699L17.3449 11.8773L16.8099 12.3988L16.9362 13.1351L16.275 12.7875L15.6137 13.1351ZM7.06377 13.1351L7.72503 12.7875L8.38629 13.1351L8.26 12.3988L8.79497 11.8773L8.05566 11.7699L7.72503 11.1L7.3944 11.7699L6.65509 11.8773L7.19006 12.3988L7.06377 13.1351ZM9.35091 9.52648L9.14163 10.2436L8.6997 9.64131L7.95296 9.66389L8.38925 9.05745L8.13702 8.35425L8.8486 8.58178L9.43945 8.12459L9.44294 8.87166L10.0603 9.29231L9.35091 9.52648ZM15.5078 16.095L15.7171 15.3779L16.4265 15.1437L15.8091 14.723L15.8056 13.976L15.2148 14.4332L14.5032 14.2056L14.7554 14.9088L14.3191 15.5153L15.0658 15.4927L15.5078 16.095ZM15.6134 9.43908L15.4041 10.1562L14.9622 9.55391L14.2154 9.57649L14.6517 8.97005L14.3995 8.26684L15.1111 8.49438L15.7019 8.03719L15.7054 8.78426L16.3228 9.20491L15.6134 9.43908ZM9.31612 16.3065L9.5254 15.5894L10.2348 15.3552L9.61743 14.9346L9.61394 14.1875L9.02309 14.6447L8.31151 14.4171L8.56374 15.1203L8.12745 15.7268L8.87418 15.7042L9.31612 16.3065Z",
        fill: "#FECA00"
      })]
    })]
  })]
}));
//# sourceMappingURL=Dominica.js.map